<form
  #form="ngForm"
  (ngSubmit)="formSubmit(form.valid! && !disabled && !readonly && !anyLoading)"
  [ngFormOptions]="{ updateOn: compact ? 'submit' : undefined }"
  [class.submitted]="form.submitted"
>
  <modal
    *ngIf="compact"
    [compact]="true"
    [class.compact]="true"
    (close)="close.emit()"
    (closeMethodRef)="closeMethodRef = $event"
  >
    <div class="rv-grid-large rv-rows rv-shrink">
      <loadable
        *ngIf="load || { loading: loading, erred: erred } as loadable"
        class="non-relative rv-grid rv-shrink"
        [data]="loadable"
      >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </loadable>
      <div class="grid-inner">
        <footer class="column-small-12 rv-button-set">
          <button
            rivButton
            [variant]="'ghost'"
            [size]="'medium'"
            type="button"
            (click)="setCloseMethod('Click cancel'); close.emit()"
          >
            Cancel
          </button>
          <button
            rivButton
            [variant]="'primary'"
            [size]="'medium'"
            type="submit"
            (click)="setCloseMethod('Click done'); close.emit()"
          >
            Done
          </button>
        </footer>
      </div>
    </div>
  </modal>
  <modal
    *ngIf="!compact"
    [title]="title"
    [outerWidth]="outerWidth"
    [width]="width"
    [noScroll]="anyLoading"
    (close)="close.emit()"
    (closeMethodRef)="closeMethodRef = $event"
    [allowOverflow]="allowOverflow"
    [backgroundShading]="backgroundShading"
    [overrideFooter]="overrideFooter"
  >
    <ng-container class="header-extras">
      <ng-content select=".header-extras"></ng-content>
    </ng-container>
    <ng-container header-bottom>
      <ng-content select="[header-bottom]"></ng-content>
    </ng-container>
    <ng-container
      *ngIf="load || { loading: loading, erred: erred } as loadable"
    >
      <loadable
        class="non-relative"
        [ngClass]="loadableClass"
        [data]="loadable"
      >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </loadable>
    </ng-container>
    <footer
      [class]="deleteText == null ? '' : 'footer-with-delete'"
      class="rv-button-set"
    >
      <div *ngIf="deleteText != null">
        <button
          rivButton
          [variant]="'danger'"
          [size]="'medium'"
          type="button"
          (click)="setCloseMethod('Click delete'); delete.emit()"
        >
          {{ deleteText }}
        </button>
      </div>
      <ng-content select="[left-footer]"></ng-content>
      <div class="spacer"></div>
      <button
        rivButton
        [variant]="'ghost'"
        [size]="'medium'"
        type="button"
        (click)="
          $event.preventDefault();
          setCloseMethod(readonly ? 'Click close' : 'Click cancel');
          close.emit()
        "
      >
        {{ readonly ? 'Close' : 'Cancel' }}
      </button>
      <ng-template #submitButton>
        <input
          *ngIf="!readonly"
          [disabled]="submitting || disabled || anyLoading"
          type="submit"
          value="{{ submitting ? submittingText : submitText }}"
          rivButton
          [variant]="'primary'"
          [size]="'medium'"
          (click)="setCloseMethod('Click submit')"
        />
      </ng-template>
      <ng-container *ngIf="submitTooltip; else submitButton">
        <span [rivTooltip]="submitTooltip">
          <ng-container *ngTemplateOutlet="submitButton"></ng-container>
        </span>
      </ng-container>
    </footer>
  </modal>
</form>
<ng-template #content><ng-content></ng-content></ng-template>
